import notifyPhantomWhenMounted from './notifyPhantomWhenMounted';
export default notifyPhantomWhenMounted;



// WEBPACK FOOTER //
// ./src/components/notifyPhantomWhenMounted/index.js